export default "__VITE_ASSET__BgkgX$WK__"